export const DAILY_LEARN_HARD_CAP = 30;
